define('AwaLabs.LoginForPricing', [
    'QuantityPricing.View',
    'Header.MiniCartItemCell.View',
    'Header.MiniCart.View',
    'Profile.Model',
    'SC.Configuration',
    'Backbone',
    'underscore',
    'AwaLabs.AddModelToContext'
], function AwaLabsLoginForPricing(
    QuantityPricingView,
    HeaderMiniCartItemCellView,
    HeaderMiniCartView,
    ProfileModel,
    Configuration,
    Backbone,
    _
) {
    'use strict';

    var loginToSeePriceField = 'custitem_awa_login_to_see_price';

    function getItemValue(item, fieldId) {
        if (!item) {
            return null;
        }

        return typeof item.get === 'function' ? item.get(fieldId) : item[fieldId];
    }

    function isEnabled(value) {
        return value === true || value === 'T' || value === 'true' || value === 1 || value === '1';
    }

    function resolveItem(source) {
        var item;

        if (!source) {
            return null;
        }

        if (source.item) {
            return source.item;
        }

        if (typeof source.getItem === 'function') {
            item = source.getItem();
            if (item) {
                return item;
            }
        }

        if (typeof source.get === 'function') {
            item = source.get('item');
            if (item) {
                return item;
            }
        }

        return source;
    }

    function resolveLines(model) {
        var lines = model && (model.lines || typeof model.get === 'function' && model.get('lines'));

        return lines && lines.models || lines || [];
    }

    function isBuyFluShotsHost() {
        var currentHost = typeof window !== 'undefined' && window.location && window.location.hostname;

        if (!currentHost && typeof SC !== 'undefined' && SC.ENVIRONMENT) {
            currentHost = SC.ENVIRONMENT.currentHostString;
        }

        currentHost = String(currentHost || '').toLowerCase();

        return currentHost === 'buyflushots.nmsincusa.com' ||
            currentHost === 'buyflu-sandbox.ethanablatt.com';
    }

    function requiresLoginForPrice(item) {
        return isEnabled(getItemValue(item, loginToSeePriceField));
    }

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            ProfileModel = ProfileModel.ProfileModel || ProfileModel;
            var profileModel = ProfileModel.getInstance();
            var isLoginForPriceActive = isBuyFluShotsHost() || isEnabled(Configuration.get('loginForPricing.active'));

            function shouldRestrict(item) {
                return profileModel.get('isLoggedIn') !== 'T' && requiresLoginForPrice(resolveItem(item));
            }

            HeaderMiniCartView.addExtraContextProperty = Backbone.View.addExtraContextProperty;
            HeaderMiniCartItemCellView.addExtraContextProperty = Backbone.View.addExtraContextProperty;
            QuantityPricingView.addExtraContextProperty = Backbone.View.addExtraContextProperty;

            if (isLoginForPriceActive) {
                // Hides add to cart button if user not logged in and item has flag
                layout.addToViewContextDefinition('Cart.AddToCart.Button.View', 'isCurrentItemPurchasable', 'boolean',
                function changeIsCurrentItemPurchasable(context) {
                    var model = context.model;
                    var item = model && model.item;

                    if (!item && model && typeof model.getItem === 'function') {
                        item = model.getItem();
                    }

                    if (!item && model && typeof model.get === 'function') {
                        item = model.get('item');
                    }

                    item = item || model;

                    return context.isCurrentItemPurchasable && !(
                        profileModel.get('isLoggedIn') !== 'T' &&
                        isEnabled(getItemValue(item, loginToSeePriceField))
                    );
                });

                // Hides quantity if user not logged in and item has flag
                layout.addToViewContextDefinition('ProductDetails.Quantity.View', 'showQuantity', 'boolean', function changeShowQuantity(context) {
                    return context.showQuantity && !shouldRestrict(context.model);
                });

                // Hides total amount on mini cart if user not logged in and item has flag
                layout.addToViewContextDefinition('Header.MiniCart.View', 'isPriceEnabled', 'boolean', function changeIsPriceEnabled(context) {
                    var anyLoginToSeePrice = _.any(resolveLines(context.model), function anyLoginToSeePrice(line) {
                        return shouldRestrict(line);
                    });

                    return context.isPriceEnabled && !anyLoginToSeePrice;
                });

                // Hides price if user not logged in and item has flag
                layout.addToViewContextDefinition('QuantityPricing.View', 'showContent', 'boolean', function changeShowContent(context) {
                    return context.showContent && !shouldRestrict(context.model);
                });

                // Hides price on transactional lines if user not logged in and item has flag
                layout.addToViewContextDefinition('Transaction.Line.Views.Price.View', 'isPriceEnabled', 'boolean', function changeIsPriceEnabled(context) {
                    return context.isPriceEnabled && !shouldRestrict(context.model);
                });

                // Changes price to login to see prices if user not logged in and item has flag
                layout.addToViewContextDefinition('Cart.Item.Summary.View', 'isPriceEnabled', 'boolean', function changeShowContent(context) {
                    return context.isPriceEnabled && !shouldRestrict(context.line);
                });

                // Changes summary ammount to login to see prices if user not logged in and item has flag
                layout.addToViewContextDefinition('Cart.Summary.View', 'isPriceEnabled', 'boolean', function changeIsPriceEnabled(context) {
                    var anyLoginToSeePrice = _.any(resolveLines(context.model), function anyLoginToSeePrice(line) {
                        return shouldRestrict(line);
                    });

                    return context.isPriceEnabled && !anyLoginToSeePrice;
                });

                // Changes header mini cart item price to login to see prices if user not logged in and item has flag
                layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'isPriceEnabled', 'boolean', function changeIsPriceEnabled(context) {
                    return context.isPriceEnabled && !shouldRestrict(context.line);
                });

                // Changes product price to login to see prices if user not logged in and item has flag
                layout.addToViewContextDefinition('ProductViews.Price.View', 'isPriceEnabled', 'boolean', function changeIsPriceEnabled(context) {
                    return context.isPriceEnabled && !shouldRestrict(context.model);
                });
            }
        }
    };
});
